var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:{
    avatar: _vm.extra_avatar_class,
    'user-details-avatar': !_vm.extra_avatar_class
  },attrs:{"size":_vm.$vuetify.breakpoint.mdAndDown ? _vm.mobile_size : _vm.desktop_size,"color":"primary"}},[(_vm.data && _vm.data.avatar_uri)?_c('v-img',{attrs:{"src":_vm.data && _vm.data.avatar_uri ? _vm.data.avatar_uri : ''}}):_c('span',{staticClass:"base-section-title white--text"},[_vm._v(" "+_vm._s(_vm.name_initials)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }